import { useTranslation } from 'react-i18next';

import { AnalyticsEventName } from '@/api/analytics';
import { Button } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';
import { formatNumberWithLocale } from '@/helpers/common';
import { Modals } from '@/helpers/modals';
import { useAnalytics } from '@/hooks/analytics';
import { useCommonStore, useModalsStore } from '@/store';

import { ScBonusContainer, ScRegSliderFocus } from './styled';

export const LobbyRegistrationBanner = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation(['common, bonuses']);
  const { sendEventToAnalytics } = useAnalytics();
  const registrationBannerData = useCommonStore.use.registrationBannerData();

  const open = useModalsStore.use.open();

  if (!registrationBannerData) return null;

  const { character, title, moneyValue, bonus, subTitle, banks } =
    registrationBannerData;

  const formattedMoney = formatNumberWithLocale(moneyValue, language);

  const handleRegisterClick = () => {
    open(Modals.Registration);
    sendEventToAnalytics({
      name: AnalyticsEventName.MODAL__REGISTRATION__BONUS_REGISTER__BUTTON__CLICK,
    });
  };

  return (
    <ScRegSliderFocus>
      <div className="title">{title}</div>
      <ImageComponent
        src={character.url}
        alt="characters"
        width={344}
        height={228}
      />
      <ScBonusContainer>
        <div className="max-sum">
          {t('bonuses:currencySymbol', {
            value: formattedMoney,
          })}
        </div>
        <div className="bonus">{bonus}</div>
      </ScBonusContainer>

      <Button
        primary
        wide
        large
        className="button"
        onClick={handleRegisterClick}
      >
        {t('button.register')}
      </Button>

      <div className="subtitle">{subTitle}</div>

      <div className="banks">
        {banks.map((bank, index) => (
          <ImageComponent
            key={index}
            src={bank.url}
            width={bank.width}
            height={20}
            alt="Bank logo"
            className="bank-img"
          />
        ))}
      </div>
    </ScRegSliderFocus>
  );
};
